export enum GuestReportForms {
  StartGuestReport = 'StartGuestReport',
  SubmitGuestReport = 'SubmitGuestReport',
}
